<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="'隐患台账'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="w-full h-full relative z-9999">
        <div class="flex mb-20px mr-10px">
          <el-input
            size="small"
            class="mr-10px !w-50"
            placeholder="请输入关键字"
            v-model="equipSearchData.keywords"
            clearable
          ></el-input>
          <el-select
            v-model="equipSearchData.hiddenDangerLedgerStatus"
            size="small"
            class="mr-10px !w-50 mb-10px"
            placeholder="请选择隐患状态"
            clearable
            popper-class="cockpit-select-popper"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            class="mr-10px !w-50 mb-10px"
            placeholder="请选择区域"
            v-model="equipSearchData.areaId"
            clearable
            popper-class="cockpit-select-popper"
          >
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>

          <el-select
            v-model="equipSearchData.ownedSystemOrUnit"
            size="small"
            class="mr-10px !w-50 mb-10px"
            placeholder="请选择所属系统/机组"
            clearable
            popper-class="cockpit-select-popper"
          >
            <el-option
              v-for="item in ownedSystemOrUnitList"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>

          <el-button
            class="round-button"
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch()"
          ></el-button>
        </div>
        <el-table
          :data="equipDataList"
          class="w-full"
          :height="tableHeight"
          v-loading="equipTableLoading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="隐患名称"
            prop="hiddenDangerName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所在区域"
            prop="areaStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患来源"
            prop="hiddenDangerSourceStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属机组/系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患等级"
            prop="hiddenDangerlevelStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="状态"
            prop="hiddenDangerLedgerStatusStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患类型"
            prop="hiddenDangerTypeStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患上报人"
            prop="reporterName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="上报时间" prop="reportTime" show-overflow-tooltip width="180px">
            <template slot-scope="scope">
              {{
                scope.row.reportTime
                  ? dayjs(scope.row.reportTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="隐患验收人"
            prop="personChargeHiddenDangerAcceptanceName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="验收时间"
            prop="acceptanceTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.acceptanceTime
                  ? dayjs(scope.row.acceptanceTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="goDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="prev, pager, next"
          :total="equipTotalCount"
          class="flex justify-center mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'

import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'

const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const dataCategoryApi = new DataCategoryApi()

const areaApi = new AreaApi()
const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'hidden-list',
  components: {
    CockpitDialog,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      flatArr: [],
      visible: true,
      areaList: [],
      selectionEquipData: [],
      statusList: [
        { label: '待提交', value: 0 },
        { label: '已提交', value: 1 },
        { label: '被驳回(驳回至上报)', value: 2 },
        { label: '待核实', value: 3 },
        { label: '已核实', value: 4 },
        { label: '被驳回(驳回至核实)', value: 5 },
        { label: '待整改', value: 6 },
        { label: '整改中', value: 7 },
        { label: '已整改', value: 8 },
        { label: '超期未整改', value: 9 },
        { label: '延期审核中', value: 10 },
        { label: '待验收', value: 11 },
        { label: '已验收', value: 12 },
        { label: '已销号', value: 14 },
      ],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: this.areaId,
        evaluationLevel: '',
        riskPointType: 0,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      ownedSystemOrUnitList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 120px)'
    },
  },
  created() {
    this.getDataCategory(
      ['DoublePreventionManagement.DataCategory.OwnedSystemOrUnit'],
      ['ownedSystemOrUnitList'],
      this
    )
  },
  mounted() {
    this.getEquipList()
    this.getAreaList()
  },
  methods: {
    goDetail(row) {
      const routeUrl = this.$router.resolve({
        path: '/double-prevention-management/rectification/hidden-book',
        query: {
          id: row.id,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
    // 切换查询
    changeValues(values) {
      this.handleSearch()
    },
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangerLedgerPagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    async getDataCategory(codeList = [], values = [], vue) {
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const codes = []
        codeList.forEach((item) => {
          codes.push(abpConfigList.setting.values[item])
        })
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes,
          includeDetails: true,
        })
        const codeMap = codes.reduce((pre, code, index) => {
          pre[code] = values[index]
          return pre
        }, {})
        if (!statusError) {
          const [err, res] = await dataCategoryApi.getListByIds({
            ids: statusRes.map((item) => {
              return item.id
            }),
            includeDetails: true,
          })
          if (!err) {
            res.forEach((item) => {
              vue[codeMap[item.code]] = item.dataItems.map((i) => {
                return {
                  value: i.code,
                  label: i.displayName,
                  ...i,
                }
              })
            })
          }
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/styles/filterSelect.scss';
</style>
<style scoped lang="scss">
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';
@import '../../../assets/styles/loading.scss';

::v-deep .round-button {
  line-height: 1;
}
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
</style>
